export default __webpack_public_path__ + "static/media/cocktail2.b08204a4.jpg";